import React from "react";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import styles from './play.module.css';

export default function Play(props) {
  const { handleClick } = props;

  return (
    <button className={styles.playbutton} onClick={() => handleClick()}>
      <PlayCircleFilledIcon />
    </button>
  );
}
